import {cachedCustomerAuthentication, queryBearerToken} from "./UserAuthentication";
import * as ActionTypes from "../constants/ActionTypes";
import {queryArticleOptionData, queryBaseArticle} from "./ArticleData";
import {queryPreloadedCart} from "./Cart";
import {queryTopLevelDomains} from "./Domain";
import {engine} from "../index";
import {agencyServerProjectArticles} from "../config/Config";
import {queryPromotionCodeInit, queryPromotionCodeStatusAndData} from "./PromotionCode";
import {initialize as initializeForms} from "redux-form";
import {putFormData} from "./FormData";
import {closeCollapsibleContent, openCollapsibleContent, toggleSelectionTriggered} from "./Util";
import {selectLatestValidStep} from "./StepControl";
import {appInitialized} from "./AppInit";
import {getAgencyServerProjectArticlesInCartSplit, getConsumerArticlesInCartSplit} from "../selectors/ProjectSelection";
import {getSoftwareLoaders} from "./AppInit.SoftwareLoaders";
import {isAgencyServer} from "../selectors/ArticleNumbers";
import {getArticleOptionsInCartList, getDomainInCartList} from "../selectors/CartUtil";
import {getArticleOptionsData, getCart, getCartBackupRange, getCartCommissionValue, getCartPaymentSettings, getCartPhoneVerificationNote, getCartProjectName, getCartProjectPassword, getCartPromotionCode, getCartTesting} from "../selectors/SimpleSelectors";
import {getInitialBillingAddress, getInitialContactPerson, getInitialContractPartner, getInitialSepaData, getPhoneVerification} from "../selectors/Forms";
import {selectBaseArticle} from "./BaseArticle";
import {selectCartProperty} from "./Properties";
import {ARTICLE_TYPE_BASE, DOMAIN_TYPE_CUSTOM, DOMAIN_TYPE_DEV, INVOICE_TYPE_EMAIL, INVOICE_TYPE_POST, PAYMENT_TYPE_INVOICE, PAYMENT_TYPE_SEPA, PROJECT_STATE_LIVE, PROJECT_TYPE_CREATE, PROJECT_TYPE_SKIP} from "../constants/General";
import {getSelectedStateByArticle, getSelectedTypeByArticle} from "../selectors/ArticleConfigurator";

export const initializeAppWithCart = (baseArticleId, cartId, initParams) => (dispatch, getState) => {

    const {initialArticles, initialPromotionCode/*, initialPromotionCode, initialDomains, initialContract*/} = initParams

    Promise.all([
        dispatch(queryBearerToken())
    ]).then((args) => {
        if (args[0].type !== ActionTypes.BEARER_TOKEN_FAILURE) {

            const initialCalls = [
                queryBaseArticle(baseArticleId),
                queryPreloadedCart(cartId),
                queryTopLevelDomains()
            ]

            Promise.all(initialCalls.map(func => dispatch(func))).then((args) => {
                if (args[1].type === ActionTypes.CART_UPDATE_FAILURE) {
                    alert("Dieser Warenkorb konnte nicht geladen werden. Die Seite wird automatisch neu geladen.")
                    engine.save({})
                    top.location.reload()
                }
                if (args[0].type === ActionTypes.BASE_ARTICLE_SUCCESS
                    && args[1].type === ActionTypes.CART_UPDATE_SUCCESS
                    && args[2].type === ActionTypes.TOPLEVELDOMAINS_SUCCESS) {

                    Promise.all([
                        ...getSoftwareLoaders(getState().articleData.baseArticle.type).map(func => dispatch(func)),
                        // iterate through articleOptions and load data if price not available
                        dispatch(queryArticleOptionData(
                            [
                                ...initialArticles.filter(key => {
                                    return (getState().articleData.articleOptions[key] && getState().articleData.articleOptions[key].price) ? null : key
                                }),
                                ...isAgencyServer(baseArticleId) ? agencyServerProjectArticles : [],
                                ...(Object.keys(getState().articleData.articleOptions).filter(key => {
                                    return (key.includes("default") || getState().articleData.articleOptions[key].price) ? null : key
                                }))
                            ]
                        ))
                    ]).then((args) => {


                        dispatch({
                            type: ActionTypes.BASE_ARTICLE_LOAD_COMPLETE
                        })

                        // verify cart items
                        const articleOptionData = getArticleOptionsData(getState())
                        //todo: use isDevProjectInCart selector
                        let isDevProjectInCart = false;

                        getArticleOptionsInCartList(getState()).forEach(articleOptionNumber => {
                            if (!articleOptionData[articleOptionNumber]) {
                                console.log("Ungültiger Warenkorbinhalt!")
                            }
                            if (articleOptionNumber + "" === "72002") {
                                isDevProjectInCart = true;
                            }
                        })

                        const domainsInCart = getDomainInCartList(getState());

                        if (isDevProjectInCart && domainsInCart.length === 0) {
                            dispatch(toggleSelectionTriggered('domainType', DOMAIN_TYPE_DEV))
                        } else {
                            if (getCartTesting(getState())) {
                                dispatch(toggleSelectionTriggered('domainType', DOMAIN_TYPE_DEV))
                            } else {
                                dispatch(toggleSelectionTriggered('domainType', DOMAIN_TYPE_CUSTOM))
                            }
                        }

                        if (getCartPromotionCode(getState())) {
                            dispatch(queryPromotionCodeInit())
                            dispatch(initializeForms('promotionCodeForm',
                                {
                                    promotionCode: getCartPromotionCode(getState())
                                }
                            ))
                        } else {

                            if (initialPromotionCode) {

                                dispatch(initializeForms('promotionCodeForm',
                                    {
                                        promotionCode: initialPromotionCode
                                    }
                                ))

                                dispatch(queryPromotionCodeStatusAndData()).then(args => {
                                    dispatch(appInitialized(initParams))
                                    dispatch(putFormData())
                                })
                            }

                        }

                        if (getCartCommissionValue(getState())) {
                            dispatch(initializeForms('commissionForm',
                                {
                                    commission: getCartCommissionValue(getState())
                                }
                            ))
                        }

                        const paymentSettings = getCartPaymentSettings(getState())

                        if (paymentSettings && 'postalInvoice' in paymentSettings) {
                            if (paymentSettings.postalInvoice) {

                                dispatch(toggleSelectionTriggered('invoiceType', INVOICE_TYPE_POST))

                            } else {

                                dispatch(toggleSelectionTriggered('invoiceType', INVOICE_TYPE_EMAIL))

                            }
                        }

                        if (paymentSettings && 'billingType' in paymentSettings) {

                            if (paymentSettings.billingType === PAYMENT_TYPE_INVOICE) {

                                dispatch(toggleSelectionTriggered('billingType', PAYMENT_TYPE_INVOICE))

                            } else {

                                dispatch(toggleSelectionTriggered('billingType', PAYMENT_TYPE_SEPA))

                                dispatch(initializeForms('sepaPayment',
                                    getInitialSepaData(getState())
                                ))

                            }
                        }

                        if (!getState().token.isAuthenticatedUser) {
                            // update forms with exisitng cart data if available in cart
                            if (getInitialBillingAddress(getState())) {
                                dispatch(initializeForms('billingAddress',
                                    getInitialBillingAddress(getState())
                                ))

                                // open/close collapsibles whether data is set or not
                                if (getInitialBillingAddress(getState()).firstName) {
                                    dispatch(openCollapsibleContent('billingAddress'))
                                } else {
                                    dispatch(closeCollapsibleContent('billingAddress'))
                                }
                            }

                            if (getInitialContactPerson(getState())) {
                                dispatch(initializeForms('contactPerson',
                                    getInitialContactPerson(getState())
                                ))

                                // open/close collapsibles whether data is set or not
                                if (getInitialContactPerson(getState()).firstName) {
                                    dispatch(openCollapsibleContent('contactPerson'))
                                } else {
                                    dispatch(closeCollapsibleContent('contactPerson'))
                                }
                            }

                            if (getInitialContractPartner(getState())) {
                                dispatch(initializeForms('contractPartner',
                                    getInitialContractPartner(getState())
                                ))
                            }

                            const phoneVerification = getPhoneVerification(getState())
                            // check for phone verification
                            if (phoneVerification) {

                            } else {
                                dispatch(toggleSelectionTriggered('phoneVerificationType', 'phone'))

                                dispatch(initializeForms('phoneVerification',
                                    {
                                        note: getCartPhoneVerificationNote(getState())
                                    }
                                ))

                            }

                        } else {
                            dispatch(cachedCustomerAuthentication())
                        }

                        if (getCart(getState()) && getCart(getState()).backupRange) {
                            dispatch(selectCartProperty("backupRange", getCart(getState()).backupRange, false));
                        }

                        if (getCart(getState()) && getCart(getState()).software) {
                            dispatch(selectCartProperty("software", getCart(getState()).software, false));
                        }

                        if (getCart(getState()) && getCart(getState()).billingPeriod) {
                            dispatch(selectCartProperty("billingPeriod", getCart(getState()).billingPeriod, false));
                        }


                        dispatch(selectLatestValidStep())

                        if (getCartTesting(getState())) {
                            dispatch(initializeForms('testing',
                                {
                                    testing: true
                                }
                            ))
                        }

                        // initialize agency project selection
                        if (isAgencyServer(baseArticleId)) {

                            const projectArticlesInCart = getAgencyServerProjectArticlesInCartSplit(getState());

                            if (projectArticlesInCart.article.length > 0) {

                                const initialValues = {
                                    article: projectArticlesInCart.article[0].articleNumber,
                                    storage: projectArticlesInCart.storage.length > 0 ? projectArticlesInCart.storage[0].articleNumber : "",
                                    backup: getCartBackupRange(getState()) || "",
                                    type: getSelectedTypeByArticle(projectArticlesInCart.article[0].articleNumber),
                                    state: getSelectedStateByArticle(projectArticlesInCart.article[0].articleNumber)
                                };

                                dispatch(toggleSelectionTriggered('projectConfiguration', PROJECT_TYPE_CREATE))

                                const projectNameInCart = getCartProjectName(getState());
                                const passwordInCart = getCartProjectPassword(getState());

                                if (projectNameInCart) {
                                    dispatch(selectCartProperty("projectName", projectNameInCart, false));
                                    initialValues.projectName = projectNameInCart;
                                }

                                if (passwordInCart) {
                                    dispatch(selectCartProperty("projectPasswordInCart", passwordInCart, false));
                                    initialValues.projectPasswordInCart = passwordInCart;
                                }

                                dispatch(initializeForms('projectSelection', initialValues))

                            } else {

                                dispatch(toggleSelectionTriggered('projectConfiguration', PROJECT_TYPE_SKIP))

                            }

                        } else {
                            // init storage
                            const consumerArticlesInCart = getConsumerArticlesInCartSplit(getState());

                            const initialValues = {
                                article: "" + baseArticleId,
                                storage: consumerArticlesInCart.storage.length > 0 ? consumerArticlesInCart.storage[0].articleNumber : "",
                                backup: getCartBackupRange(getState()) || 7,
                                type: ARTICLE_TYPE_BASE,
                                state: PROJECT_STATE_LIVE
                            }

                            const projectNameInCart = getCartProjectName(getState());
                            const passwordInCart = getCartProjectPassword(getState());

                            if (projectNameInCart) {
                                dispatch(selectCartProperty("projectName", projectNameInCart, false));
                                initialValues.projectName = projectNameInCart;
                            }

                            if (passwordInCart) {
                                dispatch(selectCartProperty("projectPasswordInCart", passwordInCart, false));
                                initialValues.projectPasswordInCart = passwordInCart;
                            }

                            dispatch(initializeForms('projectSelection', initialValues))
                        }

                        dispatch(selectBaseArticle(baseArticleId))

                        // app initialized
                        dispatch(appInitialized(initParams))

                    })

                }
            })
        }
    })
}



/** WEBPACK FOOTER **
 ** ./src/actions/AppInit.WithCart.js
 **/